import styled from 'styled-components';
import { styledComponentProps } from '../../types/theme';

export const MarginTop = styled.div<any>`
	margin-top: ${({ size, auto }: styledComponentProps): string => {
		if (!auto) {
			return `${size}px`;
		}
		return 'auto';
	}};
`;

export const MarginBottom = styled.div<any>`
	margin-bottom: ${({ size }: styledComponentProps): number | undefined =>
		size}px;
`;

export const MarginRight = styled.div<any>`
	margin-right: ${({ size, auto }: styledComponentProps): string => {
		if (!auto) {
			return `${size}px`;
		}
		return 'auto';
	}};
`;

export const MarginLeft = styled.div<any>`
	margin-left: ${({ size }: styledComponentProps): number | undefined =>
		size}px;
`;
